import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography, withWidth, withStyles, Button, Link } from "@material-ui/core";

const styles = theme => ({
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    color: theme.palette.common.white,
    border: '1px solid whitesmoke',
    borderRadius: 5,
    padding: 20,
    height: '100%',
  },
  gridContainer: {
    width: '60%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 20,
    [theme.breakpoints.down("md")]: {
      width: '70%',
    },
    [theme.breakpoints.down("sm")]: {
      width: '90%',
    },
    [theme.breakpoints.down("xs")]: {
      width: '100%',
    },
  },
});

const solutions = [
  {
    id: 'nswh',
    name: 'NexSpec Warehouse',
    headline: 'We deliver complete control to content owners. Our Warehouse solution stores, manages, and securely protects your mezzanine assets.',
    bullets: [
      'Seamlessly work with vendors to package source assets.',
      'Flexibility for future fulfillment management.',
      'Quickly ingest delivered packages for near-instant inventory management.'
    ]
  },
  {
    id: 'nsbp',
    name: 'NexSpec Backplane',
    headline: 'The workflow automation platform.',
    bullets: [
      'Streamline disparate systems and processes and remove redundancies',
      'Manage and automate workflows',
      'Connect, access, and integrate relevant data to create operational efficiencies across legacy and cloud-based content workflows'
    ]
  },
  {
    id: 'nxml',
    name: 'NxML',
    headline: 'We are fluent in MEC/MMC. Easily input metadata into our UI to generate spec-compliant XMLs.',
    bullets: [
      'Create MEC/MMC compliant packages in minutes',
      'Scale delivery volumes with confidence',
      'Go live faster'
    ]
  },
  {
    id: 'avacreator',
    name: 'Avails Creator',
    headline: 'Centralized avails information and management.',
    bullets: [
      'Easy UI to input avails data',
      'Validate and generate all relevant platform avails reliably',
      'Regenerate all avails in one click'
    ]
  },
  {
    id: 'salesreporting',
    name: 'Sales Reporting',
    headline: 'Consolidated daily sales performance reports and dashboards.',
    bullets: [
      'API/email integration to platform data',
      'Aggregated reporting visibility',
      'Track performance across time, genres, promotions, and more'
    ]
  },
  {
    id: 'ultramezz',
    name: 'UltraMezz Formatting',
    headline: 'Process, transform, and upgrade your legacy assets to be future-proofed and platform ready.',
    bullets: [
      'Simplify what assets need management and what can be created on demand',
      'Content owners deliver once to meet all platform specifications',
      'A well-defined specification leads to an easy-to-understand inventory'
    ]
  },
]

function MainSection({ classes }) {
  return (
    <>
      <Grid container spacing={2} className={classes.gridContainer}>
        {solutions.map(solution => (
          <Grid key={`cta-${solution.id}`} item sm={12} md={6}>
            <Box className={classes.cardWrapper}>
              <Typography variant="body1" style={{fontSize: '1.5rem', textAlign: 'center'}}>{solution.name}</Typography>
              <Typography variant="body1" style={{textAlign: 'left', marginBottom: 3}}>{solution.headline}</Typography>
              <Box flexGrow={1}>
                <ul>
                  {solution.bullets.map((bullet, bInd) => (
                    <li 
                      key={`bullet-${solution.id}-${bInd}`} 
                      style={{textAlign: 'left'}}
                    >
                      {bullet}
                    </li>
                  ))}
                </ul>
              </Box>
            </Box>
          </Grid>
        ))}
        <Grid item xs={12} style={{textAlign: 'center', marginTop: 20}}>
          <Button variant="contained" style={{backgroundColor: '#f27e30'}}>
            <Link href="/contact" style={{textDecoration: 'none'}}><Typography variant="h4" style={{color: 'whitesmoke'}}>Contact us for a demo and pricing</Typography></Link>
          </Button>
        </Grid>
      </Grid>
      
    </>
  );
}

MainSection.propTypes = {
  width: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(withWidth()(MainSection));
